export enum SizeUnit {
  CM = '0',
  IN = '1'
}
